// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"296":"9815665d","736":"417a921d","767":"317acc3b"}[chunkId] + ".css";
};